import { render, staticRenderFns } from "./confirmDeletionDomainModal.vue?vue&type=template&id=a850341c&"
import script from "./confirmDeletionDomainModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionDomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports